import React, { useState } from "react";

/**
 * 제출 시간 셀 — 평소엔 날짜만, 마우스를 올리면 전체 일시를 툴팁으로 보여줍니다.
 *
 * 사용법:
 *   <SubmittedTime value={record.submitted_at} />
 *   <SubmittedTime value={null} />            // → "미제출"
 */

const DAYS = ["일", "월", "화", "수", "목", "금", "토"];

const formatShort = (d) => {
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${mm}/${dd}`;
};

const formatFull = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const day = DAYS[d.getDay()];
  const h24 = d.getHours();
  const ampm = h24 < 12 ? "오전" : "오후";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const min = String(d.getMinutes()).padStart(2, "0");
  const sec = String(d.getSeconds()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} (${day}) ${ampm} ${h12}:${min}:${sec} 제출`;
};

const SubmittedTime = ({ value, emptyText = "미제출" }) => {
  const [hovered, setHovered] = useState(false);

  if (!value) {
    return (
      <span style={{ fontSize: "13px", color: "#7A8490", whiteSpace: "nowrap" }}>
        {emptyText}
      </span>
    );
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return (
      <span style={{ fontSize: "13px", color: "#3A434E", whiteSpace: "nowrap" }}>
        {String(value)}
      </span>
    );
  }

  return (
    <span
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "relative",
        display: "inline-block",
        fontSize: "13px",
        fontWeight: 600,
        color: "#3A434E",
        whiteSpace: "nowrap",
        cursor: "default",
        letterSpacing: "-0.01em",
      }}
    >
      {formatShort(date)} 제출
      {hovered && (
        <span
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            right: 0,
            backgroundColor: "#0E141B",
            color: "#FFF",
            fontSize: "12px",
            fontWeight: 700,
            padding: "7px 12px",
            borderRadius: "9px",
            whiteSpace: "nowrap",
            boxShadow: "0 8px 22px rgba(14, 20, 27, .25)",
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          {formatFull(date)}
          <span
            style={{
              position: "absolute",
              top: "100%",
              right: "14px",
              width: 0,
              height: 0,
              border: "5px solid transparent",
              borderTopColor: "#0E141B",
            }}
          />
        </span>
      )}
    </span>
  );
};

export default SubmittedTime;
